import React, { useEffect, useState } from 'react';
import {
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBTypography,
  MDBSpinner,
  MDBBtn,
  MDBInput,
  MDBRow,
  MDBCol,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter

} from 'mdb-react-ui-kit';

function InventoryTab({ user }) {
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [errorMessage, setErrorMessage] = useState('');
  const [sortOption, setSortOption] = useState('product_no');

  const [productNo, setProductNo] = useState('');
  const [quantity, setQuantity] = useState('');


  const [showModal, setShowModal] = useState(false);

  const [newItem, setNewItem] = useState({
    product_no: '',
    description: '',
    sold_qty: 0,
    total_qty: '',
    reserved_qty: 0,
    unit: '',
    unit_cost: '',
    expiry_date: ''
  });


  const fetchInventory = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://krizkhen-floral-design.onrender.com/api/inventory/get-all-inventory');
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      setInventory(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInventory();
  }, []);

  const handleAction = async (action) => {
    setErrorMessage('');
    if (!productNo || !quantity) {
      setErrorMessage('Please enter product number and quantity');
      return;
    }

    try {
      const response = await fetch(`https://krizkhen-floral-design.onrender.com/api/inventory/${action}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_no: productNo, quantity: Number(quantity) }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Action failed');

      fetchInventory();
      setProductNo('');
      setQuantity('');
    } catch (err) {
      setErrorMessage(err.message);
    }
  };

  const handleCreateItem = async () => {
    try {
      const response = await fetch('https://krizkhen-floral-design.onrender.com/api/inventory/create-inventory', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newItem)
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Failed to create inventory item');

      setShowModal(false);
      fetchInventory();
      setNewItem({ product_no: '', description: '', total_qty: '', reserved_qty: 0, unit: '', unit_cost: '', expiry_date: '' });
    } catch (error) {
      alert(error.message);
    }
  };


  if (loading) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <MDBSpinner role="status">
          <span className="visually-hidden">Loading...</span>
        </MDBSpinner>
      </div>
    );
  }

  if (error) {
    return (
      <MDBTypography tag="p" className="text-danger text-center mt-4">
        Error: {error}
      </MDBTypography>
    );
  }

  const sortedInventory = [...inventory].sort((a, b) => {
    if (!sortOption) return 0;
    if (sortOption === 'available_qty') return (a.total_qty - a.reserved_qty) - (b.total_qty - b.reserved_qty);
    if (sortOption === 'expiry_date') return new Date(a.expiry_date) - new Date(b.expiry_date);
    return a[sortOption] > b[sortOption] ? 1 : -1;
  });

  return (
    <div className="mt-4 w-100">
      {/* Inventory Title and Sorting on the same row */}
      <MDBRow className="align-items-center mb-4">
        <MDBCol>
          <MDBTypography tag="h1" className="custom-font" style={{ color: '#A78D79' }}>
            Inventory
          </MDBTypography>
        </MDBCol>

        <MDBCol md="auto" className="d-flex align-items-center justify-content-end ms-auto">
          <div className="d-flex align-items-center gap-3">
            <div className="d-flex align-items-center gap-2">
              <MDBTypography className="mb-0 me-1" style={{ whiteSpace: 'nowrap' }}>Sort by:</MDBTypography>
              <select
                className="form-select"
                value={sortOption}
                onChange={(e) => setSortOption(e.target.value)}
                style={{ minWidth: '180px' }}
              >
                <option value="product_no">Material No#</option>
                <option value="total_qty">Total Qty</option>
                <option value="available_qty">Available Qty</option>
                <option value="expiry_date">Expiry Date</option>
              </select>
            </div>

            {user?.role === 'admin' && (
              <MDBBtn style={{backgroundColor:'#A78D79'}} onClick={() => setShowModal(true)}>
                ADD ITEM
              </MDBBtn>
            )}
          </div>
        </MDBCol>
      </MDBRow>



      {/* Admin controls (only for admins) */}
      {user?.role === 'admin' && (
        <MDBRow className="mb-2 g-2 align-items-center">
          <MDBCol md="auto">
            <MDBInput
              label="Material No#"
              value={productNo}
              onChange={(e) => setProductNo(e.target.value)}
            />
          </MDBCol>

          <MDBCol md="auto">
            <MDBInput
              label="Quantity"
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
          </MDBCol>

          <MDBCol md="auto" className="ms-2">
            <MDBBtn color="success" onClick={() => handleAction('add-stock')}>
              Add Stock
            </MDBBtn>
          </MDBCol>

          <MDBCol md="auto">
            <MDBBtn color="warning" onClick={() => handleAction('remove-stock')}>
              Remove Stock
            </MDBBtn>
          </MDBCol>

          <MDBCol md="auto">
            <MDBBtn color="danger" onClick={() => handleAction('mark-expired')}>
              Mark Expired
            </MDBBtn>
          </MDBCol>

          {/* Inline error message */}
          <MDBCol md="auto" className="d-flex align-items-center">
            {errorMessage && (
              <MDBTypography tag="p" className="text-danger mb-0 ms-2" style={{ fontSize: '14px' }}>
                {errorMessage}
              </MDBTypography>
            )}
          </MDBCol>
        </MDBRow>
      )}



      {/* Inventory Table */}
      <div className="mt-4" style={{ width: '100%', overflowX: 'auto' }}>
        <MDBTable bordered hover responsive>
        <MDBTableHead>
        <tr>
            <th className="fw-bold">Material No#</th>
            <th className="fw-bold">Description</th>
            <th className="fw-bold">Sold Qty</th>
            <th className="fw-bold">Total Qty</th>
            <th className="fw-bold">Reserved Qty</th>
            <th className="fw-bold">Available Qty</th>
            <th className="fw-bold">Unit</th>
            <th className="fw-bold">Unit Cost</th>
        </tr>
        </MDBTableHead>

          <MDBTableBody>
            {sortedInventory.length > 0 ? (
              sortedInventory.map(item => (
                <tr key={item._id}>
                  <td>{item.product_no}</td>
                  <td>{item.description}</td>
                  <td>{item.sold_qty}</td>
                  <td>{item.total_qty}</td>
                  <td>{item.reserved_qty}</td>
                  <td>{item.total_qty - item.reserved_qty}</td>
                  <td>{item.unit}</td>
                  <td>₱{item.unit_cost.toFixed(2)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  No inventory found
                </td>
              </tr>
            )}
          </MDBTableBody>
        </MDBTable>
      </div>

      {/* ADD ITEM MODAL */}
      <MDBModal open={showModal} tabIndex="-1">
        <MDBModalDialog centered>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Add New Inventory Item</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={() => setShowModal(false)}></MDBBtn>
            </MDBModalHeader>

            <MDBModalBody>
              <MDBInput
                className="mb-3"
                label="Material No#"
                value={newItem.product_no}
                onChange={(e) => setNewItem({ ...newItem, product_no: e.target.value })}
              />
              <MDBInput
                className="mb-3"
                label="Description"
                value={newItem.description}
                onChange={(e) => setNewItem({ ...newItem, description: e.target.value })}
              />
              <MDBInput
                className="mb-3"
                label="Total Quantity"
                type="number"
                value={newItem.total_qty}
                onChange={(e) => setNewItem({ ...newItem, total_qty: e.target.value })}
              />
              <MDBInput
                className="mb-3"
                label="Unit"
                value={newItem.unit}
                onChange={(e) => setNewItem({ ...newItem, unit: e.target.value })}
              />
              <MDBInput
                className="mb-3"
                label="Unit Cost"
                type="number"
                value={newItem.unit_cost}
                onChange={(e) => setNewItem({ ...newItem, unit_cost: e.target.value })}
              />
              <MDBInput
                className="mb-3"
                label="Expiry Date"
                type="date"
                value={newItem.expiry_date}
                onChange={(e) => setNewItem({ ...newItem, expiry_date: e.target.value })}
              />

              {errorMessage && (
                <p className="text-danger small mb-0">{errorMessage}</p>
              )}
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn color="danger" onClick={() => setShowModal(false)}>
                Cancel
              </MDBBtn>
              <MDBBtn color="success" onClick={handleCreateItem}>
                Add Item
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

    </div>
  );
}

export default InventoryTab;